import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function WhyItFailed() {
  const failures = [{
    title: 'Dietas restrictivas',
    desc: 'Te dejan con hambre y te rompen el sueño → rebote seguro.'
  }, {
    title: 'HIIT / entrenar duro',
    desc: 'Sube más tu cortisol (estrés) → más antojo y fatiga crónica.'
  }, {
    title: 'Perfección 3 días + caída 4',
    desc: 'Tu cuerpo aprende el ciclo de restricción/atracón y lo repite.'
  }];
  return <Section background="white" data-id="element-148">
      <h2 className="text-3xl font-bold text-center text-[#2C2C2C] mb-12" data-id="element-149">
        Por qué lo que intentaste falló
      </h2>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-150">
        {failures.map((item, idx) => <div key={idx} className="bg-[#FFF8F0] p-6 rounded-xl border border-[#E8DED3]" data-id="element-151">
            <div className="flex items-center mb-4" data-id="element-152">
              <XCircle className="h-6 w-6 text-[#D4735E] mr-3" data-id="element-153" />
              <h3 className="font-bold text-[#2C2C2C]" data-id="element-154">{item.title}</h3>
            </div>
            <p className="text-[#5A5A5A] text-sm leading-relaxed" data-id="element-155">
              {item.desc}
            </p>
          </div>)}
      </div>

      <p className="text-center mt-12 text-lg font-medium text-[#2C2C2C]" data-id="element-156">
        La mayoría intenta ganar esta etapa con castigo. <br data-id="element-157" />
        <span className="text-[#D4735E]" data-id="element-158">Y esa estrategia ya no te paga.</span>
      </p>
    </Section>;
}